$('.form.add-to-downloadfolder-form').each(function(_, element){
    var form = $(element).find('form');

    form.on('submit', function(ev){
        ev.preventDefault();

        var url = form.attr('action');
        var data = form.serializeArray();

        Belimo.Downloadfolder.submit(url, data, function() {
            form.find('button').attr('disabled', 'disabled');
        });
        return false;
    });
});

$('.add-to-downloadfolder-link').each(function(_, element){
    $(element).on('click', function(ev){
        ev.preventDefault();

        var $link = $(ev.currentTarget);
        var url = $link.attr('href');
        var data = [{
            name: 'documentCode',
            value: $link.data('csid')
        }];

        Belimo.Downloadfolder.submit(url, data);
        $link.html($link.data('added'));
        $link.addClass('orange');
        return false;
    });
});
